<div class="p-1">
  W celu wykonania podpisu w wersji przeglądarki Google Chrome, Opera i Mozilla
  Firefox wymagana jest instalacja dedykowanego rozszerzenia
  <b>Podpis elektroniczny Szafir SDK</b> oraz dodatkowej aplikacji
  <b>Szafir Host</b>
  udostępniającej funkcje podpisu elektronicznego.
  <br /><br />

  <b>
    <a
      target="_blank"
      href="https://chromewebstore.google.com/detail/szafir-sdk-web/gjalhnomhafafofonpdihihjnbafkipc"
    >
      Instalacja rozszerzenia Szafir SDK z Web Store dla Chrome
    </a>
  </b>
  <br />

  <b>
    <a
      target="_blank"
      href="https://chromewebstore.google.com/detail/szafir-sdk-web/gjalhnomhafafofonpdihihjnbafkipc"
    >
      Instalacja rozszerzenia Szafir SDK z Web Store dla Opera
    </a>
  </b>
  <br />

  <b>
    <a
      target="_blank"
      href="https://www.elektronicznypodpis.pl/download/webmodule/firefox/szafir_sdk_web-current.xpi"
    >
      Instalacja rozszerzenia Szafir SDK z Web Store dla Mozilla Firefox
    </a>
  </b>
  <br /><br />

  <b>
    <a href="szafir/szafirhost.msi" download>
      Szafir Host dla systemu Windows 64-bit
    </a>
  </b>
  <br />

  <b>
    <a href="szafir/szafirhost_x86.msi" download>
      Szafir Host dla systemu Windows 32-bit
    </a>
  </b>
  <br /><br />

  Po zainstalowaniu rozszerzenia Szafir SDK oraz aplikacji Szafir Host należy
  przeładować bieżącą stronę. Jeżeli rozszerzenie oraz aplikacja zostały
  prawidłowo zainstalowane i mimo tego nadal pojawia się niniejszy komunikat,
  należy sprawdzić czy:
  <ul>
    <li>w przeglądarce włączone jest rozszerzenie Szafir SDK,</li>
    <li>
      na komputerze zainstalowane jest środowisko uruchomieniowe Java JRE.
    </li>
  </ul>

  Środowisko Java JRE można pobrać i zainstalować z lokalizacji:
  <b>
    <a target="_blank" href="https://www.java.com/pl/download/">
      Java JRE
    </a> </b
  >.
</div>
<div class="flex justify-end">
  <p-button
    styleClass="customInfoButton outlined"
    size="small"
    (click)="dynamicDialogRef.close()"
    [label]="'Zamknij'"
  />
</div>
